(function( countrySwitcherService, $, undefined ) {

    tippy('[data-tippy-content]', {
        theme: 'press',
        animation: 'shift-toward',
    });

}( elabs.TooltipService = elabs.TooltipService || {} ));